import { render, staticRenderFns } from "./AccountSettingSocial.vue?vue&type=template&id=35f42a24&scoped=true&"
import script from "./AccountSettingSocial.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSocial.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingSocial.vue?vue&type=style&index=0&id=35f42a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f42a24",
  null
  
)

export default component.exports